// extracted by mini-css-extract-plugin
export default {"inputForm":"LoginForm_inputForm__QR5Xu","inputFormWrapper":"LoginForm_inputFormWrapper__RBIiO","error":"LoginForm_error__012y+"};